import React, { useEffect, useState, useMemo, useRef } from 'react';
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";
import { PTable } from '../ptable';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import Loader from "../loader";
import { agGridCommonConfig } from '../../config/agGridConfig';
import { AgGridReact } from 'ag-grid-react';
import { deleteproduct, listcategory, listproduct } from '../../service/dataservice';

export const Productlist = () => {
    const nav = useNavigate();
    const loc = useLocation();
    const { page } = useParams();
    const [editId, setEditId] = useState(0);
    const [loading, setLoading] = useState(false);
    // 🔹 Table data
    const [rowData, setRowData] = useState([]);
    let [Categorytype_list, setCategorytype_list] = useState([]);

    // Toggle active status with Swal confirmation
    const handleToggleActive = (id, currentStatus) => {
        const newStatus = currentStatus == 1 ? 0 : 1;
        const actionText = currentStatus == 1 ? "inactive" : "active";

        Swal.fire({
            title: `Are you sure you want to ${actionText}?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            confirmButtonColor: currentStatus == 1 ? "#d33" : "#28a745",
            cancelButtonColor: "#6c757d",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                const data = new FormData();
                data.append("id", id);
                data.append("status", newStatus);

                deleteproduct(data)
                    .then((res) => {
                        setLoading(false);
                        if (res.status) {
                            toast.success(res.message);
                            DispLoadData();
                        } else {
                            toast.error(res.message);
                        }
                    })
                    .catch((err) => {
                        setLoading(false);
                        toast.error(err.message);
                    });
            }
        });
    };

    const gridRef = useRef();
    const columnDefs = useMemo(() => [
        {
            headerName: "Actions",
            width: 100,
            cellRenderer: (params) => (
                <div className="d-flex justify-content-center">
                    <Button
                        variant="primary"
                        size="sm"
                        onClick={() => handleEdit(params.data)}
                    >
                        <i className="fa fa-edit"></i>
                    </Button>
                </div>
            ),
            filter: false,
            sortable: false,
        },
        {
            headerName: "Status",
            field: "active",
            width: 80,
            cellRenderer: (params) => (
                <label className="switch">
                    <input
                        type="checkbox"
                        checked={params.data.active == 1}
                        onChange={() => handleToggleActive(params.data.id, params.data.active)}
                    />
                    <span className="slider round"></span>
                </label>
            ),
            filter: false,
            sortable: false,
        },
        {
            headerName: "Image",
            field: "product_images",
            cellRenderer: (params) => {
                const images = params.value; // 👈 single value now

                return images && images.length > 0 ? (
                    <div style={{ display: "flex", gap: "4px" }}>
                        {images.slice(0, 3).map((img, index) => (
                            <img
                                key={index}
                                src={img}
                                alt={`product-${index}`}
                                style={{
                                    height: "40px",
                                    width: "40px",
                                    objectFit: "cover",
                                    borderRadius: "4px",
                                    border: "1px solid #ddd"
                                }}
                            />
                        ))}
                    </div>
                ) : (
                    <span>No Image</span>
                );
            },
            filter: false,
            sortable: false,
        },
        {
            headerName: "Category",
            field: "product_category",
            floatingFilter: true,
            valueGetter: (params) => {
                return params.data.product_category?.category_name || "";
            }
        },
        {
            headerName: "Product Name",
            field: "product_name",
            floatingFilter: true,
        },


    ], [Categorytype_list]);


    useEffect(() => {
        DispLoadData();
    }, [page]);

    useEffect(() => {
        let data = new FormData();
        data.append("active", 1);
        listcategory(data).then((res) => {
            if (res.status) {
                setCategorytype_list(res.data);
            }
            else toast.error(res.message);
        })
            .catch((err) => toast.error(err.message));
    }, [])

    const DispLoadData = () => {
        // setLoading(true);
        let data = new FormData();

        // For deleted list, show only inactive. For main list, show all.
        if (page === "deleteproduct") {
            data.append("active", 0);
        }

        listproduct(data)
            .then((res) => {
                setLoading(false);
                if (res.status) setRowData(res.data);
                else toast.error(res.message);
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err.message);
            });
    }
    // 🟠 Edit item
    const handleEdit = (row) => {
        nav('/product/editproduct/' + row.id);
    };

    // 🔴 Delete item
    const handleDelete = (id) => {
        Swal.fire({
            title: "Are you sure want to delete?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            dangerMode: true,
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                const data = new FormData();
                data.append("id", id);
                // Dataservice.CallAPI("deleteproduct", data)
                //     .then((res) => {
                //         setLoading(false);
                //         if (res.status) DispLoadData();
                //         else toast.error(res.message);
                //     })
                //     .catch((err) => {
                //         setLoading(false);
                //         toast.error(err.message);
                //     });
            }
        });
    };

    return (

        <div>
            {loading && <Loader />}
            <div className="page-title mb-4">
                <div className="row g-2 align-items-center">
                    <div className="col-sm-6">
                        <h4>Product List</h4>
                    </div>
                    {/* <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-end mb-0">
                            <li className="breadcrumb-item">
                                <li className="breadcrumb-item">
                                    Dashboard
                                </li>
                            </li>
                            <li className="breadcrumb-item">Product</li>
                            <li className="breadcrumb-item active">Product List</li>
                        </ol>
                    </div> */}
                </div>
            </div>

            {/* Container-fluid starts */}
            <div className="mb-3">
                <div className="text-end mb-3">
                    <Button variant="success" onClick={() => nav("/product/addproduct")}>
                        <i className="fa fa-plus me-2"></i> Add Product
                    </Button>
                </div>
                <div className="ag-theme-alpine" style={{ height: agGridCommonConfig.tableHeight, width: "100%" }}>
                    <AgGridReact
                        ref={gridRef}
                        rowData={rowData}
                        columnDefs={columnDefs}
                        {...agGridCommonConfig}   // ✅ inject all common settings
                    />
                </div>
            </div>

        </div>
    )
}
